export const CONTENT_WIDTH = '360px';

export const MAX_UINT_256_VALUE = BigInt(2 ** 256) - 1n;
export const MAX_UINT_48_VALUE = BigInt(2 ** 48) - 1n;
export const MAX_UINT_160_VALUE = BigInt(2 ** 160) - 1n;
